import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
.set('Search', new Immutable.List([]))
.set('Response', new Immutable.Map({}))
.set('Get', new Immutable.Map({}))
.set('GetValidateYear', new Immutable.Map({}))
.set('ValidateYear', new Immutable.Map({}));

/* Types */
export const GET_FINANCIAL = 'GET_FINANCIAL'
export const GET_VALIDATE_YEAR = 'GET_VALIDATE_YEAR'
export const VALIDATE_YEAR = 'VALIDATE_YEAR'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_FINANCIAL:
			return state.set('Get', new Immutable.Map(action.Obj))
		case GET_VALIDATE_YEAR:
			return state.set('GetValidateYear', new Immutable.Map(action.Obj))
		case VALIDATE_YEAR:
			return state.set('ValidateYear', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getFinancial = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getFinancial',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			const data = response.data

			let formFinancial = {}

			if (data.informacionFinanciera.financieraEjercicioFiscal[0]) {

				let dataFinancial = data.informacionFinanciera.financieraEjercicioFiscal[0]

				let ingresos = dataFinancial.ingresos || {}
				let egresos = dataFinancial.egresos || {}
				let activos = dataFinancial.activos || {}
				let pasivos = dataFinancial.pasivos || {}

				formFinancial = {
					uniqueId: Utils.getUUID(),
					aportacionPatronos: ingresos.aportacionPatronConsejero || "",
					gastosOperativos: egresos.gastosOperativos || "",
					cuotasAsociados: ingresos.cuotasAsociados || "",
					gastosAdministrativos: egresos.gastosAdministrativos || "",
					donativosPersonas: ingresos.donativosPersonasFisicas || "",
					otrosGastos: egresos.otrosGastos || "",
					donativosEmpresas: ingresos.donativosPersonasMorales || "",
					donativosNMP: ingresos.donativosNMP || "",
					oscNacionales: ingresos.oscNacionales || "",
					oscInternacionales: ingresos.oscInternacionales || "",
					gastosRecaudacion: egresos.recaudacionFondos || "",
					donativosGobierno: ingresos.donativosGobierno || "",
					rendimientoPatrimoniales: ingresos.rendimientoFondosPatrimoniales || "",
					ingresosArrendamiento: ingresos.arrendamiento || "",
					cuotasRecuperacion: ingresos.cuotasRecuperacion || "",
					actividadesProductivas: ingresos.actividadesProductivas || "",
					otrasActividades: ingresos.otrasActividades || "",
					descripcionOtrasActividades: ingresos.descripcionOtrasActividades || "",
					activoCirculante: activos.activoCirculante || "",
					proveedores: pasivos.proveedores || "",
					activoFijo: activos.activoFijo || "",
					cuentasPagar: pasivos.cuentasPorPagar || "",
					activoDiferido: activos.activoDiferido || "",
					impuestos: pasivos.impuestos || "",
					otrosPasivos: pasivos.otrosPasivos || "",
					pasivoLargo: pasivos.pasivoLargoPlazo || "",
					pasivoCorto: pasivos.patrimonio || "",
					numeroEmpleados: dataFinancial.numeroEmpleados || "",
					numeroHombresRemunerados: dataFinancial.numeroHombresRemunerados || "",
					numeroMujeresRemunerados: dataFinancial.numeroMujeresRemunerados || "",
					numeroOtrosGenerosRemunerados: dataFinancial.numeroOtrosGenerosRemunerados || "",
					numeroVoluntarios: dataFinancial.numeroVoluntarios || "",
					numeroHombresVoluntarios: dataFinancial.numeroHombresVoluntarios || "",
					numeroMujeresVoluntarios: dataFinancial.numeroMujeresVoluntarios || "",
					numeroOtrosGenerosVoluntarios: dataFinancial.numeroOtrosGenerosVoluntarios || "",
					numeroTransporte: dataFinancial.numeroEquiposTransporte || "",
					speciesDonationCheck: (dataFinancial.donativoEspecie.descripcionDonativo && dataFinancial.donativoEspecie.descripcionDonativo !== "") ? true : false,
					speciesDonation: dataFinancial.donativoEspecie.descripcionDonativo || "",
					ammountDonation: dataFinancial.donativoEspecie.montoDonativo || "",
					subtotalEgresos: egresos.subtotalEgreso || "",
					totalIngresos: ingresos.totalIngreso || "",
					totalegresos: egresos.totalEgreso || "",
					subtotalPasivos: pasivos.subtotalPasivoCirculante || "",
					totalActivos: activos.totalActivo || "",
					totalPasivos: pasivos.totalPasivoMasCapital || "",
					firstTotal: dataFinancial.resultadoEjercicio || "",
					secondTotal: dataFinancial.gastoAdministrativo || ""
				}
				// se asignan a hombres los voluntarios y remunerados por defecto para donatarias existentes
				if(!formFinancial.numeroHombresRemunerados && !formFinancial.numeroMujeresVoluntarios && !formFinancial.numeroOtrosGenerosRemunerados)
					formFinancial.numeroHombresRemunerados = formFinancial.numeroEmpleados;
				if(!formFinancial.numeroHombresVoluntarios && !formFinancial.numeroMujeresVoluntarios && !formFinancial.numeroOtrosGenerosVoluntarios)
					formFinancial.numeroHombresVoluntarios = formFinancial.numeroVoluntarios;	
			}

			dispatch({ type: GET_FINANCIAL, Obj: formFinancial})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setFinancial = (form) => {

	let temp = {
		idDonataria: form.idDonataria,
		ejercicioFiscal: {
			idEjercicioFiscal: form.idEjercicioFiscal
		},
		informacionFinanciera: {
			ingresos: {
				aportacionPatronConsejero: form.aportacionPatronos || 0,
				cuotasAsociados: form.cuotasAsociados || 0,
				donativosPersonasFisicas: form.donativosPersonas || 0,
				donativosPersonasMorales: form.donativosEmpresas || 0,
				donativosNMP: form.donativosNMP || 0,
				oscNacionales: form.oscNacionales || 0,
				oscInternacionales: form.oscInternacionales || 0,
				donativosGobierno: form.donativosGobierno || 0,
				rendimientosFondos: form.rendimientoPatrimoniales || 0,
				rendimientoFondosPatrimoniales: form.rendimientoPatrimoniales || 0,
				arrendamiento: form.ingresosArrendamiento || 0,
				cuotasRecuperacion: form.cuotasRecuperacion || 0,
				actividadesProductivas: form.actividadesProductivas || 0,
				otrasActividades: form.otrasActividades || 0,
				totalIngreso: form.totalIngresos || 0,
				descripcionOtrasActividades: form.descripcionOtrasActividades || ""
			},
			egresos: {
				gastosOperativos: form.gastosOperativos || 0,
				gastosAdministrativos: form.gastosAdministrativos || 0,
				otrosGastos: form.otrosGastos || 0,
				subtotalEgreso: form.subtotalEgresos || 0,
				recaudacionFondos: form.gastosRecaudacion || 0,
				totalEgreso: form.totalEgresos || 0
			},
			pasivos: {
				proveedores : form.proveedores || 0,
				cuentasPorPagar : form.cuentasPagar || 0,
				impuestos : form.impuestos || 0,
				otrosPasivos : form.otrosPasivos || 0,
				subtotalPasivoCirculante : form.subtotalPasivos || 0,
				pasivoLargoPlazo : form.pasivoLargo || 0,
				patrimonio : form.pasivoCorto || 0,
				totalPasivoMasCapital : form.totalPasivos || 0
			},
			activos: {
				activoCirculante : form.activoCirculante || 0,
				activoFijo : form.activoFijo || 0,
				activoDiferido : form.activoDiferido || 0,
				totalActivo : form.totalActivos || 0
			},
			resultadoEjercicio: form.firstTotal || 0,
			gastoAdministrativo: form.secondTotal || 0,
			numeroEmpleados: form.numeroEmpleados || 0,
			numeroVoluntarios: form.numeroVoluntarios || 0,
			numeroEquiposTransporte: form.numeroTransporte || 0,
			donativoEspecie: {
				descripcionDonativo: form.speciesDonationCheck ? form.speciesDonation : "",
				montoDonativo: form.speciesDonationCheck ? form.ammountDonation : 0
			},
			numeroHombresVoluntarios: form.numeroHombresVoluntarios || 0,
      numeroMujeresVoluntarios: form.numeroMujeresVoluntarios || 0,
      numeroOtrosGenerosVoluntarios: form.numeroOtrosGenerosVoluntarios || 0,
      numeroHombresRemunerados: form.numeroHombresRemunerados || 0,
      numeroMujeresRemunerados: form.numeroMujeresRemunerados || 0,
      numeroOtrosGenerosRemunerados: form.numeroOtrosGenerosRemunerados || 0
		}
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setFinancial',
			method: "POST",
			data: temp,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}


export const getValidateYear = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getValidateYear',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			const data = response.data

			dispatch({ type: GET_VALIDATE_YEAR, Obj: data})
			return data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setValidateYear = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setValidateYear',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return 0
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const updateValidateYear = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/updateValidateYear',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return 0
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const validateYear = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/validateYear',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			const data = response.data

			dispatch({ type: VALIDATE_YEAR, Obj: data})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Information/Financial.js